import {Device} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/config.types';

export const hasAppOnlyRedeemableDevices = (redeemableDevices: Device[]) => {
  return redeemableDevices.every(
    device => device === Device.IOS_APP || device === Device.ANDROID_APP,
  );
};
